const eventsCache = {
  WordPress: null,
  Faicon: null,
};

const daysCache = new Map();

const daysCacheKey = (source, eventId) => `${source}:${eventId}`;

export function getCachedEvents(source) {
  return eventsCache[source] || null;
}

export function setCachedEvents(source, events) {
  eventsCache[source] = events;
}

export function getCachedDays(source, eventId) {
  if (!source || !eventId) return null;
  return daysCache.get(daysCacheKey(source, eventId)) || null;
}

export function setCachedDays(source, eventId, days) {
  if (!source || !eventId) return;
  daysCache.set(daysCacheKey(source, eventId), days);
}

